// Local imports
import DownloadLink from "../../DownloadLink";
import classes from "./style.module.css";
import languageConfig from "@/export/config";

// Component props for Glyphs
interface Props {
  cssName: string;
  downloadPath: string;
}

export default function Glyphs({ cssName, downloadPath }: Props) {
  return (
    <div className={`${classes.container}`}>
      <div className={`${classes.glyphContainer}`}>
        <h3 className={`${classes.glyphTitle}`}>
          {languageConfig?.routes.fonts?.glyphs.vowels.titleEn} (
          {languageConfig?.routes.fonts?.glyphs.vowels.titleMl})
        </h3>
        <div className={`${classes.letters} ${classes.vowels}`}>
          {languageConfig?.routes.fonts?.glyphs.vowels.letters.map((letter) => (
            <span
              key={letter}
              className={`${classes.letter}`}
              style={{
                fontFamily: cssName,
              }}
            >
              {letter}
            </span>
          ))}
        </div>
      </div>

      <div className={`${classes.glyphContainer}`}>
        <h3 className={`${classes.glyphTitle}`}>
          {languageConfig?.routes.fonts?.glyphs.consonants.titleEn} (
          {languageConfig?.routes.fonts?.glyphs.consonants.titleMl})
        </h3>
        <div className={`${classes.letters} ${classes.consonants}`}>
          {languageConfig?.routes.fonts?.glyphs.consonants.letters.map(
            (letter) => (
              <span
                key={letter}
                style={{
                  fontFamily: cssName,
                }}
                className={`${classes.letter}`}
              >
                {letter}
              </span>
            )
          )}
        </div>
      </div>

      <div className={`${classes.glyphContainer}`}>
        <h3 className={`${classes.glyphTitle}`}>
          {languageConfig?.routes.fonts?.glyphs.numbers.titleEn} (
          {languageConfig?.routes.fonts?.glyphs.numbers.titleMl})
        </h3>

        <div className={`${classes.letters} ${classes.numbers}`}>
          {languageConfig?.routes.fonts?.glyphs.numbers.letters.map(
            (letter) => (
              <span
                key={letter}
                className={`${classes.letter}`}
                style={{
                  fontFamily: cssName,
                }}
              >
                {letter}
              </span>
            )
          )}
        </div>
      </div>

      <DownloadLink downloadPath={downloadPath} />
    </div>
  );
}
